var AppConfig = /** @class */ (function () {
    function AppConfig() {
    }
    AppConfig.APERZA_SEARCH = 'search-aperza';
    AppConfig.APERZA_EC = 'aperza-ec';
    AppConfig.APERZA_CATALOG = 'catalog';
    AppConfig.APERZA_NEWS = 'news-aperza';
    AppConfig.APERZA_ID = 'id-aperza';
    AppConfig.APERZA_ACCOUNT = 'account-aperza';
    AppConfig.APERZA_ORDER = 'aperza-order';
    AppConfig.APERZA_BIZ = 'aperza-biz';
    AppConfig.APERZA_NECA = 'aperza-neca';
    AppConfig.APERZA_TV = 'tv';
    AppConfig.APERZA_DX = 'dx';
    AppConfig.ENV_PROD = '';
    AppConfig.ENV_STG = 'stg';
    AppConfig.ENV_TEST = 'test';
    AppConfig.ENV_TEST_2 = 'test2';
    AppConfig.ENV_LOCAL = 'local';
    AppConfig.API_HOST_PROD = 'https://api.aperza.com';
    AppConfig.API_HOST_STG = 'https://api.stg.aperza.com';
    AppConfig.API_HOST_TEST = 'https://api.test.aperza.com';
    AppConfig.API_HOST_TEST_2 = 'https://api.test2.aperza.com';
    AppConfig.API_HOST_LOCAL = 'http://localhost:8081';
    return AppConfig;
}());
export default AppConfig;
export { AppConfig };
